import React, { useEffect, useState } from "react";
import { getSparesstocklist } from "../../../services/apiService";

const StockManagement = () => {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  // Load API
  useEffect(() => {
    loadStock();
  }, []);

  const loadStock = async () => {
    try {
      const data = await getSparesstocklist();

      // convert api format
      const formatted = data.map((item) => ({
        productId: item.productid,

        name: item.modelno,

        stock: item.stock || 0,

        subcategory: item.subcategory,

        main: item.Main,
      }));

      setProducts(formatted);
    } catch (e) {
      console.log("Error loading stock", e);
    }
  };

  // Filtering
  const filteredProducts = products.filter((item) => {
    const searchText = search.toLowerCase();

    if (searchText === "low stock" || searchText === "red") {
      return item.stock <= 10;
    }

    if (searchText === "green" || searchText === "in stock") {
      return item.stock > 10;
    }

    return (
      item.name.toLowerCase().includes(searchText) ||
      item.productId.toString().includes(searchText)
    );
  });

  // Pagination

  const totalPages = Math.ceil(filteredProducts.length / pageSize);

  const startIndex = (page - 1) * pageSize;

  const paginatedProducts = filteredProducts.slice(
    startIndex,

    startIndex + pageSize,
  );

  const getStockColor = (stock, minQty) => {
    if (stock === 0) return "low-stock";
    if (stock <= minQty) return "low-stock";
    return "good-stock";
  };

  return (
    <div className="stock-container">
      <h2>Spares Stock Management</h2>

      <input
        type="text"
        placeholder="Search Product / low stock / green"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);

          setPage(1);
        }}
        className="search-box"
      />

      <table className="stock-table">
        <thead>
          <tr>
            <th>ProductId</th>

            <th>Model</th>

            <th>Category</th>

            <th>Main</th>
            <th>Stock Min Qty</th>
            <th>Stock</th>

            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          {paginatedProducts.map((item, index) => (
            <tr key={index}>
              <td>{item.productId}</td>

              <td>{item.name}</td>

              <td>{item.subcategory}</td>

              <td>{item.main}</td>

              <td>{item.stockminqty || 0}</td>
              <td>{item.stock}</td>

              <td>
                <button
                  className={`status ${getStockColor(item.stock, item.stockminqty)}`}
                >
                  {item.stock === 0
                    ? "Out of Stock"
                    : item.stock <= item.stockminqty
                      ? "Low Stock"
                      : "In Stock"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}

      <div className="pagination-container">
        <div style={{ color: "black" }}>
          Items per page:
          <select
            className="page-select"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));

              setPage(1);
            }}
          >
            {[5, 10, 20, 50].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>

        <div className="page-buttons">
          <button
            className="page-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Previous
          </button>

          <span className="page-count">
            {page} / {totalPages || 1}
          </span>

          <button
            className="page-btn"
            disabled={page === totalPages || totalPages === 0}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      </div>

      <style>
        {`

.stock-container{

padding:20px;

background:white;

font-family:Arial;

}


.search-box{

padding:8px;

width:300px;

margin-bottom:15px;

border:1px solid #ccc;

border-radius:4px;

}


.stock-table{

width:100%;

border-collapse:collapse;

}


.stock-table th{

background:#f5f5f5;

padding:10px;

border:1px solid #ddd;

text-align:left;

}


.stock-table td{

padding:10px;

border:1px solid #ddd;

}


.stock-table tr:hover{

background:#fafafa;

}


.status {

width:110px;          /* Fixed width */
height:28px;          /* Fixed height */

border:none;
border-radius:5px;

color:white;
font-size:12px;

cursor:default;       /* Not clickable look */

text-align:center;

}


.low-stock{

background:#e74c3c;

}


.good-stock{

background:#2ecc71;

}



.pagination-container{

display:flex;

justify-content:space-between;

align-items:center;

margin-top:20px;

padding:10px;

border-top:1px solid #eee;

}


.page-select{

padding:6px 10px;

border:1px solid #ccc;

border-radius:5px;

margin-left:5px;

cursor:pointer;

}


.page-buttons{

display:flex;

align-items:center;

gap:10px;

}


.page-btn{

padding:6px 14px;

border:none;

border-radius:5px;

background:#3498db;

color:white;

cursor:pointer;

}


.page-btn:hover{

background:#2980b9;

}


.page-btn:disabled{

background:#ccc;

cursor:not-allowed;

}


.page-count{

font-weight:bold;
color:black;

}


`}
      </style>
    </div>
  );
};

export default StockManagement;
